<template>
    <!-- Admin → Modelos de operación (/admin/modelos). Mismo diseño que Admin →
         Usuarios y Cupones (bkCuenta + cuentaMenu + usuariosAdmin.css) y
         modelosAdmin.css (prefijo mo-).

         El modelo define qué le cobra la plataforma al huésped, qué wizard de
         precio ve el anfitrión y qué formulario de llegada se usa. Cambiarlo rige
         de ahí en adelante: las reservas ya hechas guardan el modelo con el que se
         cerraron. Las perillas de cada modelo salen de la tabla `modelo_anfitrion`
         y se cambian por SQL: esta pantalla asigna y renombra, no define.

         Lógica y pedidos iguales que antes (ModeloAnfitrionController):
           GET   admin/modelos                         modelos asignables
           PATCH admin/modelos/{id} {nombre, descripcion}
           GET   admin/modelos/anfitriones?q&modelo&page[&per_page]
           PATCH admin/modelos/anfitriones/{id} {modelo_id|null}   null = por defecto
           GET   admin/modelos/historial?limit
         Las cifras por modelo salen del mismo listado con per_page=1. -->
    <div class="mo-page">
        <div class="bk us mo">
            <aside class="bk-side us-side">
                <router-link :to="{ name: 'admin' }" class="us-back">
                    <span aria-hidden="true" v-html="IC.back"></span>{{ $t('admin_modelos.back') }}
                </router-link>
                <h1 class="bk-title">{{ $t('admin_modelos.title_a') }} <span class="bk-grad">{{ $t('admin_modelos.title_b') }}</span></h1>
                <p class="bk-subtitle">{{ $t('admin_modelos.sub') }}</p>

                <div v-if="!sinTabla" class="us-stats mo-stats" aria-live="polite">
                    <button type="button" :class="['us-stat', { 'is-on': !filtroModelo }]" :aria-pressed="String(!filtroModelo)" @click="filtrar('')">
                        <span class="us-stat-n">{{ totalAnf == null ? '—' : numero(totalAnf) }}</span>
                        <span class="us-stat-k">{{ $t('admin_modelos.stat.hosts') }}</span>
                    </button>
                    <button v-for="m in modelos" :key="m.id" type="button" :class="['us-stat', { 'is-on': filtroModelo === m.clave }]" :aria-pressed="String(filtroModelo === m.clave)" @click="filtrar(m.clave)">
                        <span class="us-stat-n">{{ conteos[m.clave] == null ? '—' : numero(conteos[m.clave]) }}</span>
                        <span class="us-stat-k">{{ m.nombre }}</span>
                    </button>
                </div>

                <div class="us-care mo-how">
                    <h2>{{ $t('admin_modelos.how.t') }}</h2>
                    <ul>
                        <li><span aria-hidden="true" v-html="IC.next"></span>{{ $t('admin_modelos.how.s1') }}</li>
                        <li><span aria-hidden="true" v-html="IC.lock"></span>{{ $t('admin_modelos.how.s2') }}</li>
                        <li><span aria-hidden="true" v-html="IC.sliders"></span>{{ $t('admin_modelos.how.s3') }}</li>
                    </ul>
                </div>
            </aside>

            <section class="us-main mo-main" :aria-busy="String(cargando)">
                <!-- El ambiente todavía no tiene la tabla -->
                <div v-if="sinTabla" class="us-empty mo-notable" role="alert">
                    <h3>{{ $t('admin_modelos.no_table.t') }}</h3>
                    <p>{{ $t('admin_modelos.no_table.p') }} <code>sql/2026-09-23_modelo_anfitrion.sql</code></p>
                </div>

                <template v-else>
                    <!-- Modelos disponibles -->
                    <div class="mo-h-row">
                        <h2 class="mo-h">{{ $t('admin_modelos.models.title') }}</h2>
                    </div>
                    <div v-if="!modelos.length && cargandoModelos" class="mo-loading"><HyFLoader variant="inline" /></div>
                    <div v-else-if="errorModelos" class="us-empty">
                        <h3>{{ $t('admin_modelos.list.error_t') }}</h3>
                        <p>{{ $t('admin_modelos.list.error_p') }}</p>
                        <button type="button" class="bk-btn bk-btn--ghost" @click="cargarModelos">{{ $t('admin_modelos.list.retry') }}</button>
                    </div>
                    <ul v-else class="mo-models">
                        <li v-for="m in modelos" :key="m.id" :class="['mo-model', { 'is-default': m.por_defecto, 'is-edit': editando === m.id }]">
                            <form v-if="editando === m.id" class="mo-rename" novalidate @submit.prevent="guardarNombre(m)" @keydown.esc.prevent="cancelarNombre">
                                <div :class="['us-field', { 'is-invalid': errNombre }]">
                                    <label class="us-field-l" :for="`mo-n-${m.id}`">{{ $t('admin_modelos.models.name') }} <em>{{ $t('admin_modelos.models.chars', { n: borrador.nombre.length, max: 80 }) }}</em></label>
                                    <input :id="`mo-n-${m.id}`" ref="nombreInput" v-model="borrador.nombre" type="text" maxlength="80" autocomplete="off" :placeholder="$t('admin_modelos.models.name_ph')" :aria-invalid="errNombre ? 'true' : null" :aria-describedby="errNombre ? `mo-ne-${m.id}` : null" :disabled="guardandoModelo" @input="errNombre = ''" />
                                    <span v-if="errNombre" :id="`mo-ne-${m.id}`" class="us-field-e" role="alert">{{ errNombre }}</span>
                                </div>
                                <div class="us-field">
                                    <label class="us-field-l" :for="`mo-d-${m.id}`">{{ $t('admin_modelos.models.desc') }} <em>{{ $t('admin_modelos.models.chars', { n: borrador.descripcion.length, max: 255 }) }}</em></label>
                                    <textarea :id="`mo-d-${m.id}`" v-model="borrador.descripcion" rows="4" maxlength="255" :placeholder="$t('admin_modelos.models.desc_ph')" :disabled="guardandoModelo"></textarea>
                                </div>
                                <div class="mo-rename-btns">
                                    <button type="button" class="bk-btn bk-btn--ghost" :disabled="guardandoModelo" @click="cancelarNombre">{{ $t('admin_modelos.models.cancel') }}</button>
                                    <button type="submit" class="bk-btn bk-btn--primary" :disabled="guardandoModelo">
                                        <span v-if="guardandoModelo" class="bk-spinner"></span>{{ $t(guardandoModelo ? 'admin_modelos.models.saving' : 'admin_modelos.models.save') }}
                                    </button>
                                </div>
                            </form>

                            <template v-else>
                                <div class="mo-model-top">
                                    <span class="mo-model-ic" aria-hidden="true" v-html="IC.sliders"></span>
                                    <div class="mo-model-name">
                                        <h3>{{ m.nombre }}</h3>
                                        <span v-if="m.por_defecto" class="mo-default" :title="$t('admin_modelos.models.default_hint')">{{ $t('admin_modelos.models.default') }}</span>
                                    </div>
                                    <button type="button" class="us-link mo-rename-btn" :aria-label="$t('admin_modelos.models.rename_n', { n: m.nombre })" @click="editar(m)">
                                        <span aria-hidden="true" v-html="IC.edit"></span>{{ $t('admin_modelos.models.rename') }}
                                    </button>
                                </div>
                                <p v-if="m.descripcion" class="mo-model-desc">{{ m.descripcion }}</p>
                                <ul class="mo-knobs">
                                    <li v-for="k in perillas(m)" :key="k.k" :class="{ 'is-on': k.on }">
                                        <span aria-hidden="true" v-html="k.on ? IC.check : IC.minus"></span>{{ k.t }}
                                    </li>
                                </ul>
                                <div class="mo-model-foot">
                                    <span>{{ $tc('admin_modelos.models.hosts', conteos[m.clave] || 0, { n: numero(conteos[m.clave] || 0) }) }}</span>
                                    <button type="button" class="us-link" :aria-pressed="String(filtroModelo === m.clave)" @click="filtrar(m.clave, true)">
                                        {{ $t('admin_modelos.models.see') }}<span aria-hidden="true" v-html="IC.chev"></span>
                                    </button>
                                </div>
                            </template>
                        </li>
                    </ul>

                    <!-- Anfitriones -->
                    <div ref="lista" class="mo-h-row mo-h-row--list">
                        <h2 class="mo-h">{{ $t('admin_modelos.list.title') }}</h2>
                        <span v-if="!error" class="mo-count" aria-live="polite">{{ $tc('admin_modelos.list.count', meta.total || 0, { n: numero(meta.total || 0) }) }}</span>
                    </div>

                    <div class="us-toolbar">
                        <label class="us-search">
                            <span class="us-sr">{{ $t('admin_modelos.list.search_label') }}</span>
                            <span aria-hidden="true" v-html="IC.search"></span>
                            <input v-model="busqueda" type="search" autocomplete="off" spellcheck="false" :placeholder="$t('admin_modelos.list.search_ph')" @input="buscarLuego" @keydown.enter.prevent="buscarYa" />
                        </label>
                        <div class="us-filter-row">
                            <div class="us-seg us-seg--sm" role="group" :aria-label="$t('admin_modelos.list.filter')">
                                <button type="button" :class="{ 'is-on': !filtroModelo }" :aria-pressed="String(!filtroModelo)" @click="filtrar('')">{{ $t('admin_modelos.list.all') }}</button>
                                <button v-for="m in modelos" :key="m.id" type="button" :class="{ 'is-on': filtroModelo === m.clave }" :aria-pressed="String(filtroModelo === m.clave)" @click="filtrar(m.clave)">{{ m.nombre }}</button>
                            </div>
                            <button v-if="filtroModelo || q" type="button" class="us-clear" @click="limpiar">{{ $t('admin_modelos.list.clear') }}</button>
                        </div>
                    </div>

                    <div v-if="cargando && !anfitriones.length" class="mo-loading"><HyFLoader variant="inline" /></div>
                    <div v-else-if="error" class="us-empty">
                        <h3>{{ $t('admin_modelos.list.error_t') }}</h3>
                        <p>{{ $t('admin_modelos.list.error_p') }}</p>
                        <button type="button" class="bk-btn bk-btn--ghost" @click="ir(meta.pagina)">{{ $t('admin_modelos.list.retry') }}</button>
                    </div>
                    <div v-else-if="!anfitriones.length" class="us-empty">
                        <h3>{{ q ? $t('admin_modelos.list.none_q_t', { q }) : $t('admin_modelos.list.none_t') }}</h3>
                        <p>{{ $t('admin_modelos.list.none_p') }}</p>
                        <button v-if="filtroModelo || q" type="button" class="bk-btn bk-btn--ghost" @click="limpiar">{{ $t('admin_modelos.list.clear') }}</button>
                    </div>

                    <ul v-else :class="['mo-hosts', { 'is-cargando': cargando }]">
                        <li v-for="a in anfitriones" :key="a.idusuario" :class="['mo-host', { 'is-saving': guardando === a.idusuario, 'is-done': hecho === a.idusuario }]">
                            <div class="us-who mo-who">
                                <span class="us-av us-av--a" aria-hidden="true">{{ iniciales(a) }}</span>
                                <div class="us-who-t">
                                    <b>{{ a.nombre || $t('admin_modelos.list.no_name') }}</b>
                                    <small><span class="us-mono">#{{ a.idusuario }}</span> · {{ a.correo }}</small>
                                </div>
                            </div>
                            <div class="mo-host-model">
                                <span :class="['mo-tag', { 'is-inherited': a.heredado, 'is-old': esHistorico(a) }]">{{ a.modelo ? a.modelo.nombre : '—' }}</span>
                                <small>{{ a.heredado ? $t('admin_modelos.list.inherited') : (esHistorico(a) ? $t('admin_modelos.list.historic_tag') : $t('admin_modelos.list.own')) }}</small>
                            </div>
                            <label class="us-sel mo-sel">
                                <span class="us-sr">{{ $t('admin_modelos.list.model_label', { n: a.nombre || a.correo }) }}</span>
                                <select :value="valorSelect(a)" :disabled="guardando === a.idusuario" @change="pedirCambio(a, $event)">
                                    <option value="">{{ $t('admin_modelos.list.default_opt', { m: nombreDefecto }) }}</option>
                                    <option v-for="m in modelos" :key="m.id" :value="String(m.id)">{{ m.nombre }}</option>
                                    <!-- Quedó en un modelo que ya no se ofrece (histórico): sin esta
                                         opción el select se vería vacío. Se puede sacar, no volver. -->
                                    <option v-if="esHistorico(a)" :value="String(a.modelo.id)" disabled>{{ $t('admin_modelos.list.historic', { m: a.modelo.nombre }) }}</option>
                                </select>
                            </label>
                            <div class="mo-host-act">
                                <span v-if="guardando === a.idusuario" class="mo-saving" role="status"><span class="bk-spinner mo-spin" aria-hidden="true"></span><span class="us-sr">{{ $t('admin_modelos.list.saving') }}</span></span>
                                <router-link v-else-if="puedeUsuarios" class="bk-btn bk-btn--ghost mo-icon-btn" :to="{ name: 'admin-usuarios', query: { u: String(a.idusuario) } }" :aria-label="$t('admin_modelos.list.user', { n: a.nombre || a.correo })" :title="$t('admin_modelos.list.user', { n: a.nombre || a.correo })">
                                    <span aria-hidden="true" v-html="IC.user"></span>
                                </router-link>
                            </div>
                        </li>
                    </ul>

                    <BkPaginacion :actual="meta.pagina || 1" :ultima="meta.ultima || 1" :total="meta.total" @ir="irA" />

                    <!-- Historial -->
                    <section class="mo-hist" aria-labelledby="mo-hist-t">
                        <div class="mo-h-row">
                            <h2 id="mo-hist-t" class="mo-h">{{ $t('admin_modelos.hist.title') }}</h2>
                        </div>
                        <p v-if="!historial.length" class="us-muted">{{ $t('admin_modelos.hist.none') }}</p>
                        <ol v-else class="us-tl mo-tl">
                            <li v-for="h in historial" :key="h.id" class="us-tl-i us-tl-i--edit">
                                <span class="us-tl-dot" aria-hidden="true"></span>
                                <div class="us-tl-t">
                                    <b>{{ h.anfitrion || '—' }}</b>
                                    <small>
                                        <span class="mo-from">{{ nombreClave(h.modelo_anterior) }}</span>
                                        <span class="us-sr">{{ $t('admin_modelos.hist.to') }}</span><span class="mo-arrow" aria-hidden="true">→</span>
                                        <span class="mo-to">{{ nombreClave(h.modelo_nuevo) }}</span>
                                        · {{ h.cambiado_por ? $t('admin_modelos.hist.by', { a: h.cambiado_por }) : $t('admin_modelos.hist.system') }}
                                    </small>
                                </div>
                                <span class="us-tl-f">{{ fecha(h.created_at) }}</span>
                            </li>
                        </ol>
                    </section>
                </template>
            </section>
        </div>

        <!-- Confirmación -->
        <div v-if="modal" class="us-modal">
            <div class="us-modal-bg" @click="responderModal(false)"></div>
            <div ref="modalCard" class="us-modal-card" role="alertdialog" aria-modal="true" aria-labelledby="mo-m-title" aria-describedby="mo-m-text" @keydown="teclaModal">
                <h2 id="mo-m-title">{{ modal.titulo }}</h2>
                <p id="mo-m-text">{{ modal.texto }}</p>
                <div class="us-modal-btns">
                    <button type="button" class="bk-btn bk-btn--ghost" @click="responderModal(false)">{{ $t('admin_modelos.k.cancel') }}</button>
                    <button ref="modalOk" type="button" class="bk-btn bk-btn--primary" @click="responderModal(true)">{{ modal.ok }}</button>
                </div>
            </div>
        </div>

        <transition name="us-toast">
            <div v-if="aviso" :class="['us-toast', `us-toast--${aviso.tipo}`]" role="status" aria-live="polite">
                <span class="us-toast-ico" aria-hidden="true">{{ aviso.tipo === 'ok' ? '✓' : '!' }}</span><span>{{ aviso.txt }}</span>
            </div>
        </transition>
    </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import BkPaginacion from '@/components/Cuenta/BkPaginacion.vue';
import HyFLoader from '@/components/Loader/HyFLoader.vue';
import ICON from '@/components/Cuenta/iconos';

const P = d => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
// Íconos: texto fijo de este archivo, nunca datos del usuario.
const IC = {
    back: P('<path d="M15 18l-6-6 6-6"/>'),
    chev: P('<path d="m9 18 6-6-6-6"/>'),
    check: P('<path d="M20 6 9 17l-5-5"/>'),
    minus: P('<path d="M6 12h12"/>'),
    search: ICON.search, lock: ICON.lock, sliders: ICON.sliders, edit: ICON.edit, user: ICON.user, next: ICON.next,
};
const LOCALES = { es: 'es-CL', en: 'en-US', pt: 'pt-BR', fr: 'fr-FR', it: 'it-IT', de: 'de-DE' };
const FLUJOS = ['checkin', 'contacto', 'ninguno'];

export default {
    name: 'Modelos',
    components: { BkPaginacion, HyFLoader },

    data() {
        const qy = this.$route.query;
        const s = k => (typeof qy[k] === 'string' ? qy[k] : '');
        return {
            IC,
            sinTabla: false,

            modelos: [], cargandoModelos: true, errorModelos: false,
            // Modelo que se está renombrando y el texto en curso.
            editando: null, guardandoModelo: false, errNombre: '',
            borrador: { nombre: '', descripcion: '' },

            anfitriones: [], cargando: true, error: false,
            meta: { pagina: Number(qy.page) > 0 ? Number(qy.page) : 1, ultima: 1, total: 0, por_defecto: null },
            busqueda: s('q'), q: s('q').trim(), filtroModelo: s('modelo'),
            guardando: null, hecho: null,

            totalAnf: null, conteos: {},
            historial: [],

            modal: null, aviso: null,
        };
    },

    computed: {
        ...mapGetters(['hasAdminPermission']),
        api() { return `${process.env.VUE_APP_API_URL}admin/modelos`; },
        loc() { return LOCALES[this.$i18n.locale] || 'es-CL'; },
        puedeUsuarios() { return this.hasAdminPermission('usuarios'); },
        // "Por defecto (Modelo 4%)": el nombre del modelo que rige sin asignación.
        nombreDefecto() {
            const d = this.modelos.find(m => m.por_defecto) || this.modelos.find(m => m.clave === this.meta.por_defecto);
            return d ? d.nombre : (this.meta.por_defecto || '—');
        },
    },

    created() {
        this._busT = null;
        this._avisoT = null;
        this._hechoT = null;
        this.cargarModelos();
        this.ir(this.meta.pagina);
        this.cargarHistorial();
    },

    beforeDestroy() {
        clearTimeout(this._busT);
        clearTimeout(this._avisoT);
        clearTimeout(this._hechoT);
    },

    methods: {
        // ── Formato ─────────────────────────────────────────────────────
        numero(n) { return Number(n || 0).toLocaleString(this.loc); },
        fecha(s) {
            if (!s) return '—';
            const d = new Date(String(s).slice(0, 19).replace(' ', 'T'));
            return isNaN(d.getTime()) ? s : d.toLocaleString(this.loc, { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
        },
        iniciales(a) {
            const p = String(a.nombre || a.correo || '?').trim().split(/\s+/).filter(Boolean);
            return ((p[0] || '?')[0] + (p.length > 1 ? p[p.length - 1][0] : '')).toUpperCase();
        },
        // El historial trae claves: se muestran con el nombre actual del modelo.
        nombreClave(clave) {
            if (!clave) return this.$t('admin_modelos.hist.default');
            const m = this.modelos.find(x => x.clave === clave);
            return m ? m.nombre : clave;
        },
        perillas(m) {
            const f = FLUJOS.includes(m.llegada_flujo) ? m.llegada_flujo : 'checkin';
            return [
                { k: 'dep', on: !!m.cobra_garantia, t: this.$t(m.cobra_garantia ? 'admin_modelos.knob.deposit_on' : 'admin_modelos.knob.deposit_off') },
                { k: 'first', on: !!m.cobra_primer_mes, t: this.$t(m.cobra_primer_mes ? 'admin_modelos.knob.first_on' : 'admin_modelos.knob.first_off') },
                { k: 'fee', on: !!m.descuenta_al_anfitrion, t: this.$t(m.descuenta_al_anfitrion ? 'admin_modelos.knob.fee_on' : 'admin_modelos.knob.fee_off') },
                { k: 'wiz', on: !!m.wizard_garantia, t: this.$t(m.wizard_garantia ? 'admin_modelos.knob.wiz_on' : 'admin_modelos.knob.wiz_off') },
                { k: 'arr', on: f !== 'ninguno', t: this.$t('admin_modelos.knob.arrival', { f: this.$t(`admin_modelos.knob.arr.${f}`) }) },
            ];
        },
        esSinTabla(e) {
            return !!(e && e.response && e.response.data && e.response.data.code === 'E_SIN_TABLA');
        },

        // ── Modelos ─────────────────────────────────────────────────────
        async cargarModelos() {
            this.cargandoModelos = true;
            this.errorModelos = false;
            try {
                const { data } = await axios.get(this.api);
                this.modelos = data.modelos || [];
                this.cargarConteos();
            } catch (e) {
                if (this.esSinTabla(e)) this.sinTabla = true;
                else { console.error('[Modelos] No se pudieron cargar los modelos', e); this.errorModelos = true; }
            } finally {
                this.cargandoModelos = false;
            }
        },
        // Cifras del lateral: el mismo listado con per_page=1 (solo se lee total).
        async cargarConteos() {
            const contar = params => axios.get(`${this.api}/anfitriones`, { params: { ...params, per_page: 1 } })
                .then(({ data }) => Number((data.meta && data.meta.total) || 0))
                .catch(() => null);
            const [total, ...porModelo] = await Promise.all([contar({}), ...this.modelos.map(m => contar({ modelo: m.clave }))]);
            this.totalAnf = total;
            const c = {};
            this.modelos.forEach((m, i) => { if (porModelo[i] != null) c[m.clave] = porModelo[i]; });
            this.conteos = c;
        },
        editar(m) {
            this.editando = m.id;
            this.errNombre = '';
            this.borrador = { nombre: m.nombre || '', descripcion: m.descripcion || '' };
            this.$nextTick(() => { const r = this.$refs.nombreInput; const el = Array.isArray(r) ? r[0] : r; if (el) el.focus(); });
        },
        cancelarNombre() {
            if (this.guardandoModelo) return;
            const id = this.editando;
            this.editando = null;
            this.errNombre = '';
            this.$nextTick(() => {
                const b = this.$el.querySelector(`.mo-model:nth-child(${this.modelos.findIndex(m => m.id === id) + 1}) .mo-rename-btn`);
                if (b) b.focus();
            });
        },
        async guardarNombre(m) {
            if (this.guardandoModelo) return;
            const nombre = this.borrador.nombre.trim();
            if (!nombre) {
                this.errNombre = this.$t('admin_modelos.models.err_name');
                const r = this.$refs.nombreInput; const el = Array.isArray(r) ? r[0] : r; if (el) el.focus();
                return;
            }
            const descripcion = this.borrador.descripcion.trim();
            // Sin cambios: se cierra sin pedir nada.
            if (nombre === (m.nombre || '') && descripcion === (m.descripcion || '')) { this.cancelarNombre(); return; }
            this.guardandoModelo = true;
            try {
                const { data } = await axios.patch(`${this.api}/${m.id}`, { nombre, descripcion });
                const i = this.modelos.findIndex(x => x.id === m.id);
                if (i !== -1 && data.modelo) this.$set(this.modelos, i, data.modelo);
                // Las filas muestran el nombre que trajo el listado: se actualiza sin recargar.
                this.anfitriones.forEach(a => { if (a.modelo && a.modelo.id === m.id) a.modelo.nombre = data.modelo ? data.modelo.nombre : nombre; });
                this.guardandoModelo = false;
                this.cancelarNombre();
                this.avisar(this.$t('admin_modelos.toast.renamed'), 'ok');
            } catch (e) {
                console.error('[Modelos] No se pudo renombrar', e);
                this.avisar(this.$t('admin_modelos.toast.rename_fail'), 'error');
            } finally {
                this.guardandoModelo = false;
            }
        },

        // ── Anfitriones ─────────────────────────────────────────────────
        async ir(pagina) {
            const req = (this._req = (this._req || 0) + 1);
            this.cargando = true;
            this.error = false;
            try {
                const { data } = await axios.get(`${this.api}/anfitriones`, {
                    params: { q: this.q, modelo: this.filtroModelo, page: pagina },
                });
                if (req !== this._req) return;
                this.anfitriones = data.anfitriones || [];
                this.meta = { ...this.meta, ...(data.meta || {}) };
                if (this.meta.ultima && pagina > this.meta.ultima) { this.ir(this.meta.ultima); return; }
                this.syncUrl();
            } catch (e) {
                if (req !== this._req) return;
                if (this.esSinTabla(e)) this.sinTabla = true;
                else { console.error('[Modelos] No se pudieron cargar los anfitriones', e); this.error = true; }
            } finally {
                if (req === this._req) this.cargando = false;
            }
        },
        irA(p) {
            this.ir(p);
            this.$nextTick(() => { const h = this.$refs.lista; if (h) h.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        },
        buscarLuego() {
            clearTimeout(this._busT);
            this._busT = setTimeout(this.buscarYa, 400);
        },
        buscarYa() {
            clearTimeout(this._busT);
            const t = this.busqueda.trim();
            if (t === this.q && !this.error) return;
            this.q = t;
            this.ir(1);
        },
        filtrar(clave, bajar) {
            if (this.filtroModelo !== clave) {
                this.filtroModelo = clave;
                this.ir(1);
            }
            if (bajar) this.$nextTick(() => { const h = this.$refs.lista; if (h) h.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        },
        limpiar() {
            clearTimeout(this._busT);
            this.busqueda = '';
            this.q = '';
            this.filtroModelo = '';
            this.ir(1);
        },
        syncUrl() {
            const query = {};
            if (this.q) query.q = this.q;
            if (this.filtroModelo) query.modelo = this.filtroModelo;
            if (this.meta.pagina > 1) query.page = String(this.meta.pagina);
            if (JSON.stringify(query) === JSON.stringify(this.$route.query)) return;
            this.$router.replace({ query }).catch(() => {});
        },

        /**
         * ¿Quedó en un modelo que ya no se ofrece? Pasa con los históricos, que
         * siguen existiendo para las reservas selladas con ellos pero no son
         * asignables.
         */
        esHistorico(a) {
            if (a.heredado || !a.modelo || !this.modelos.length) return false;
            return !this.modelos.some(m => m.id === a.modelo.id);
        },
        valorSelect(a) { return a.heredado || !a.modelo ? '' : String(a.modelo.id); },

        // Cambiar el modelo mueve plata: se confirma antes de guardar.
        async pedirCambio(a, ev) {
            const el = ev.target;
            const valor = el.value;
            const antes = this.valorSelect(a);
            if (valor === antes) return;
            const nuevo = valor === '' ? null : this.modelos.find(m => String(m.id) === valor);
            const nombreNuevo = nuevo ? nuevo.nombre : this.$t('admin_modelos.list.default_opt', { m: this.nombreDefecto });
            const nombreAntes = a.heredado ? this.$t('admin_modelos.list.default_opt', { m: this.nombreDefecto }) : (a.modelo ? a.modelo.nombre : '—');
            const ok = await this.confirmar({
                titulo: this.$t('admin_modelos.k.t'),
                texto: this.$t('admin_modelos.k.p', { n: a.nombre || a.correo, a: nombreAntes, b: nombreNuevo }),
                ok: this.$t('admin_modelos.k.ok'),
            });
            if (!ok) { el.value = antes; return; }
            this.guardando = a.idusuario;
            try {
                const { data } = await axios.patch(`${this.api}/anfitriones/${a.idusuario}`, { modelo_id: nuevo ? Number(nuevo.id) : null });
                if (data.modelo) {
                    a.modelo = data.modelo;
                    a.heredado = !!data.heredado;
                } else if (data.status === 'sin-cambios') {
                    a.heredado = !nuevo;
                }
                el.value = this.valorSelect(a);
                this.marcarHecho(a.idusuario);
                this.avisar(this.$t('admin_modelos.toast.changed', { n: a.nombre || a.correo, m: a.heredado ? this.$t('admin_modelos.list.default_opt', { m: this.nombreDefecto }) : a.modelo.nombre }), 'ok');
                this.cargarHistorial();
                this.cargarConteos();
            } catch (e) {
                const r = e && e.response;
                console.error('[Modelos] No se pudo cambiar el modelo', e);
                el.value = antes;
                this.avisar(this.$t(r && r.data && r.data.code === 'E_NO_ASIGNABLE' ? 'admin_modelos.toast.historic_fail' : 'admin_modelos.toast.change_fail'), 'error');
                // Sin cambio efectivo: se repinta con lo que sigue vigente.
                this.ir(this.meta.pagina);
            } finally {
                this.guardando = null;
            }
        },
        marcarHecho(id) {
            clearTimeout(this._hechoT);
            this.hecho = id;
            this._hechoT = setTimeout(() => { this.hecho = null; }, 1800);
        },

        async cargarHistorial() {
            try {
                const { data } = await axios.get(`${this.api}/historial`, { params: { limit: 15 } });
                this.historial = data.historial || [];
            } catch (e) {
                this.historial = [];
            }
        },

        // ── Confirmación y aviso ─────────────────────────────────────────
        confirmar({ titulo, texto, ok }) {
            return new Promise(resolve => {
                this._modalFoco = document.activeElement;
                this.modal = { titulo, texto, ok, resolve };
                this.$nextTick(() => { if (this.$refs.modalOk) this.$refs.modalOk.focus(); });
            });
        },
        responderModal(v) {
            if (!this.modal) return;
            const { resolve } = this.modal;
            this.modal = null;
            const el = this._modalFoco;
            this.$nextTick(() => { if (el && document.contains(el)) el.focus(); });
            resolve(v);
        },
        teclaModal(e) {
            if (e.key === 'Escape') { e.preventDefault(); this.responderModal(false); return; }
            if (e.key !== 'Tab') return;
            const els = Array.from(this.$refs.modalCard.querySelectorAll('button'));
            const first = els[0], last = els[els.length - 1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        },
        avisar(txt, tipo) {
            clearTimeout(this._avisoT);
            this.aviso = { txt, tipo: tipo || 'ok' };
            this._avisoT = setTimeout(() => { this.aviso = null; }, 3600);
        },
    },
};
</script>

<style src="../../BankInformation/bkCuenta.css"></style>
<style src="../../Cuenta/cuentaMenu.css"></style>
<style src="../Usuarios/usuariosAdmin.css"></style>
<style src="./modelosAdmin.css"></style>
